(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coming-soon"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const videos = document.querySelectorAll('.video-bg');

    videos.forEach(function(video) {
      video.muted = true;
      video.playsInline = true;

      function markLoaded() {
        video.classList.add('is-loaded');
      }

      function attemptPlay() {
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise
            .then(markLoaded)
            .catch(function() {
              // Autoplay blocked, retry on first user interaction
              const resumePlay = function() {
                video.play().then(markLoaded);
                document.removeEventListener('touchstart', resumePlay);
                document.removeEventListener('click', resumePlay);
              };
              document.addEventListener('touchstart', resumePlay, { once: true });
              document.addEventListener('click', resumePlay, { once: true });
            });
        }
      }

      if (video.readyState >= 3) {
        attemptPlay();
      } else {
        video.addEventListener('canplay', attemptPlay, { once: true });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
